export enum ProjectClass {
  ProfileProject = 1,
  Research = 2,
  DynamicProfile = 3
}
